import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStorageReports = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_18_77793)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M21.375 19.7083C21.375 20.625 20.625 21.375 19.7083 21.375H4.29167C3.375 21.375 2.625 20.625 2.625 19.7083V4.29167C2.625 3.375 3.375 2.625 4.29167 2.625H19.7083C20.625 2.625 21.375 3.375 21.375 4.29167V19.7083Z",
					stroke: "currentColor",
					strokeWidth: 1.5,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.20825 17.3749C8.20825 17.8749 7.87492 18.2083 7.37492 18.2083H6.54159C6.04159 18.2083 5.70825 17.8749 5.70825 17.3749V15.0416C5.70825 14.5416 6.04159 14.2083 6.54159 14.2083H7.37492C7.87492 14.2083 8.20825 14.5416 8.20825 15.0416V17.3749Z",
					stroke: "currentColor",
					strokeWidth: 1.5,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.2083 17.3749C13.2083 17.8749 12.8749 18.2082 12.3749 18.2082H11.5416C11.0416 18.2082 10.7083 17.8749 10.7083 17.3749V7.54159C10.7083 7.04159 11.0416 6.70825 11.5416 6.70825H12.3749C12.8749 6.70825 13.2083 7.04159 13.2083 7.54159V17.3749Z",
					stroke: "currentColor",
					strokeWidth: 1.5,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.2083 17.375C18.2083 17.875 17.8749 18.2083 17.3749 18.2083H16.5416C16.0416 18.2083 15.7083 17.875 15.7083 17.375V11.7083C15.7083 11.2083 16.0416 10.875 16.5416 10.875H17.3749C17.8749 10.875 18.2083 11.2083 18.2083 11.7083V17.375Z",
					stroke: "currentColor",
					strokeWidth: 1.5,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_18_77793",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white",
				transform: "translate(2 2)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgStorageReports);
export default ForwardRef;
